module.exports = __webpack_public_path__ + "img/stage-manager-16.png";